{
  "CreateYourProject": "Create Your Project",
  "BeginYourJourney": "Begin Your Journey",
  "ProjectName": "Project Name",
  "ProjectOrCompanyName": "Project or Company Name",
  "ProjectBased": "Where is your project based?",
  "SearchForCity": "Search for your city here",
  "ProjectStage": "Stage of Project",
  "Seed": "Seed",
  "SeedContinued": "Just an inkling of an idea",
  "Planning": "Planning",
  "PlanningContinued": "Prototype and testing concepts",
  "Startup": "Startup",
  "Launched": "Launched",
  "Growth": "Growth",
  "GrowthContinued": "Funded and expanded",
  "Mature": "Mature",
  "MatureContinued": "Established and steady",
  "Industry": "Industry",
  "SelectIndustry": "Select industry",
  "creating": "creating...",
  "create": "create",
  "PleaseLogin": "Please Log In",
  "InviteTeammatesHere": "Invite teammates to your project here:",

  "*required": "*required",
  "InviteTeammates": "Invite Teammates",
  "CreateProject": "Create a Project"
}
